import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import FinalCta from "@/components/FinalCta";
import { BLOG_POSTS } from "@/lib/blog";

const truncate = (s, n = 140) => (s.length > n ? `${s.slice(0, n).replace(/\s+\S*$/, "")}…` : s);

export default function BlogIndex() {
  const regions = [...new Set(BLOG_POSTS.map((p) => p.region))];
  return (
    <>
      <Seo
        title="Blog — Solar math for every major Florida city | Solar Black Belt"
        description="Guides to commercial and home solar for 32 Florida cities: the full math, real cost ranges, Powerwall questions and honest incentives context. Start with your city."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">THE SOLAR BLACK BELT BLOG</span>
          <h1 data-testid="blog-index-heading">Solar math for every major Florida city.</h1>
          <p className="lead">
            {BLOG_POSTS.length} city guides covering the same honest arithmetic: what your bill implies, what systems cost, how
            incentives move payback, and when Tesla Powerwall enters the conversation. Commercial and home — no hype, no pressure.
          </p>
        </div>
      </section>
      <section className="section" style={{ paddingTop: 40 }}>
        <div className="wrap">
          {regions.map((region) => (
            <div key={region} style={{ marginBottom: 34 }}>
              <span className="eyebrow">{region.toUpperCase()}</span>
              <div className="blog-grid" data-testid="blog-index-grid">
                {BLOG_POSTS.filter((p) => p.region === region).map((p, i) => (
                  <Reveal key={p.slug} delay={Math.min(i * 0.04, 0.2)}>
                    <article className="blog-card" data-testid={`blog-card-${p.slug}`}>
                      <h3>
                        <Link to={`/blog/${p.slug}`}>Solar in {p.city}: costs, incentives &amp; the Powerwall question</Link>
                      </h3>
                      <span className="report-tag">{p.county}</span>
                      <p>{truncate(p.blurb)}</p>
                      <Link className="micro" to={`/blog/${p.slug}`} style={{ fontWeight: 800, color: "var(--teal)" }}>
                        Read the {p.city} guide →
                      </Link>
                    </article>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <FinalCta title={["Skip ahead when you're ready"]} service="commercial" context="Blog reader quote request" />
    </>
  );
}
